import { useEffect, useState } from 'react';
import Container from '../../components/container/Container';
import {
  FormatMoneyToDisplay,
  UnitConverter,
} from '../../helper/currency-helper';
import { Stock } from '../../models/stock';
import { DUMMY_STOCKS } from '../../dummy_data/Dummy_Stock';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const ViewStockDetailsPage = () => {
  const [stock, setStock] = useState<Stock | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { id } = useParams();

  const navigate = useNavigate();

  const onBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!id) return;

    // call API
    setStock(DUMMY_STOCKS[+id - 1]);
    setLoading(false);
  }, [id]);

  if (loading === true) {
    return <div></div>;
  } else if (!stock) {
    return <div></div>;
  } else {
    return (
      <Container>
        <div>
          <div className="lg:mb-12 md:mb-8 mb-8">
            <button
              className="flex flex-row gap-2 items-center text-gray-500 hover:text-indigo-600"
              onClick={onBackClick}
            >
              <ArrowLeftIcon
                className="h-5 w-5 flex-shrink-0 hover:text-indigo-600"
                aria-hidden="true"
              />
              <span className="align-text-top">Back</span>
            </button>
          </div>

          <div className="px-4 sm:px-0">
            <h3 className="text-xl font-semibold leading-7 text-gray-900">
              {stock.ticker}
            </h3>
            <p className="mt-1 max-w-2lg text-md leading-6 text-gray-500">
              {stock.name}
            </p>
          </div>
          <div className="mt-6">
            <dl className="grid grid-cols-2 sm:grid-cols-3">
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Sector
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {stock.sector}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Industry
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {stock.industry}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Country
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {stock.country}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Market Cap
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {UnitConverter(stock.marketCap)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Daily High
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {FormatMoneyToDisplay(stock.dailyHigh)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Daily Low
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {FormatMoneyToDisplay(stock.dailyLow)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Volume
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {UnitConverter(stock.volume)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Average Volume
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {UnitConverter(stock.averageVolume)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Current Price
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {FormatMoneyToDisplay(stock.currentPrice)}
                </dd>
              </div>
              <div className="border-t border-gray-100 px-4 py-6 col-span-2 sm:col-span-3 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Description
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
                  {stock.description}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </Container>
    );
  }
};

export default ViewStockDetailsPage;
